// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-onboarding-automated-notification-dialog {
  position: relative;
}
.fi-onboarding-automated-notification-dialog .fi-dialog-close-button {
  position: absolute;
  top: 4px;
  right: 0;
  z-index: 2;
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.fi-onboarding-automated-notification-dialog .fi-dialog-close-button .mat-icon {
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-onboarding/fi-onboarding-builder/fi-onboarding-edit/fi-onboarding-automated-notification-dialog/fi-onboarding-automated-notification-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAGZ","sourcesContent":[".fi-onboarding-automated-notification-dialog {\r\n    position: relative;\r\n    .fi-dialog-close-button {\r\n        position: absolute;\r\n        top: 4px;\r\n        right: 0;\r\n        z-index: 2;\r\n        width: 24px;\r\n        height: 24px;\r\n        line-height: 24px;\r\n        .mat-icon {\r\n            width: 24px;\r\n            height: 24px;\r\n            line-height: 24px;\r\n            color: #6b7280;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
